import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pigFilled"
const PigFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M5.221 3C5.238 2.997 6.086 2.933 7.063 3.081 7.932 3.214 9.025 3.532 9.646 4.334 10.282 4.197 10.944 4.124 11.625 4.124 16.152 4.125 19.913 7.327 20.227 11.445 20.424 11.27 20.593 11.066 20.72 10.836 20.863 10.578 20.953 10.293 20.986 10 21.02 9.706 20.993 9.409 20.911 9.125L22.353 8.71C22.489 9.182 22.53 9.677 22.477 10.167 22.422 10.656 22.27 11.13 22.033 11.56 21.796 11.992 21.475 12.372 21.091 12.68 20.803 12.91 20.483 13.095 20.142 13.232 19.873 14.788 19.106 16.189 18 17.297V21.375H14.25V19.498C13.422 19.74 12.54 19.875 11.625 19.875 10.846 19.875 10.092 19.777 9.375 19.599V21.375H5.625V17.65C4.89 17.001 4.279 16.232 3.833 15.375H1.875V8.625H3.833C4.117 8.078 4.467 7.565 4.875 7.097V3.025zM7.5 9.75C6.879 9.75 6.375 10.254 6.375 10.875S6.879 12 7.5 12 8.625 11.496 8.625 10.875 8.121 9.75 7.5 9.75M10.5 7.687V8.812H14.25V7.687z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PigFilledIcon
